var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-date-picker',{attrs:{"mode":"dateTime","is-range":""},model:{value:(_vm.range),callback:function ($$v) {_vm.range=$$v},expression:"range"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }